<script lang='ts' setup>

</script>
<template>
  <q-bar class="io-mfe-ig-title-bar io-mfe-ig-title-bar-banner">
    <div class="iodine-icon-container iodine-icon-container-banner">
      <q-icon name="fa-light fa-circle-info" class="io-mfe-ig-icon-medium"/>
    </div>
    <div class="banner-container">
      <span class="banner-content banner-content-label">Read-Only Mode</span>
      <span class="banner-content banner-content-text">You are accessing a visit that is either 120 days since discharge or does not have a valid status. If you feel that this is a mistake, please contact support.</span>
    </div>

  </q-bar>
</template>
<style scoped lang="scss">

  @import "../../css/grouper.variables";

  .q-bar.io-mfe-ig-title-bar {
    height: fit-content;
    padding: 4px 16px;

    &-banner {
      display: flex;
      align-items: flex-start;
    }
  }

  .banner-content {
    color: var(--ioUI-sys-light-on-surface, #111414);
    font-family: Lato;
    font-size: 14px;
    font-style: normal;

    line-height: 20px;
    letter-spacing: 0.3px;

    &-label {
      font-weight: 600;
      display: inline-block;
      margin-right: 4px;
    }

    &-text {
      font-weight: 400;
    }
  }

  .banner-container {
    display: inline-block;
  }

  .iodine-icon-container-banner {
    margin-right: 10px;
    padding: 0;

    & > .q-icon {
      color: rgba(84, 77, 199, 1);
    }
  }

</style>
